import { forwardRef } from 'react';
import styles from './GridMenu.module.scss.js';
import { jsx } from 'react/jsx-runtime';

const GridMenuList = /*#__PURE__*/forwardRef(function GridMenuList(props, ref) {
  const {
    children
  } = props;
  return /*#__PURE__*/jsx("div", {
    className: styles['list'],
    ref: ref,
    role: "menu",
    children: children
  });
});

export { GridMenuList };
